<template>
    <Layout class="container">
        <Header class="header">
            <MyHeader @siderToggleCollapse="collapsedSider" />
        </Header>
        <Layout class="detail w-100">
            <Sider ref="navSider" hide-trigger collapsible width="230" style="overflow-y: auto;" :collapsed-width="78" v-model="isCollapsed">
                <my-sider :collapsed="isCollapsed"></my-sider>
            </Sider>
            <Content class="w-100">
                <div class="content-container">
                    <div class="main-tabs">
                        <Tabs v-model="tabsVal" type="card" :animated="false" closable @on-click="tabsClick" @on-tab-remove="tabClose">
                            <TabPane v-for="(item, i) in tabsList" :key="i" :label="item" :name="item" closable ></TabPane>
                        </Tabs>
                        <Dropdown @on-click="tabsClose" placement="bottom-end">
                            <div class="tabs-close-main">
                                <Icon type="ios-arrow-down" size="16" />
                            </div>
                            <DropdownMenu slot="list">
                                <DropdownItem name="left"><Icon type="md-arrow-back" />关闭左侧</DropdownItem>
                                <DropdownItem name="right"><Icon type="md-arrow-forward" />关闭右侧</DropdownItem>
                                <DropdownItem name="other"><Icon type="md-close" />关闭其他</DropdownItem>
                                <DropdownItem name="all"><Icon type="md-close-circle" />关闭全部</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                    <div class="main-container">
                        <keep-alive :include="keepAlive"><router-view ></router-view></keep-alive>
                    </div>
                </div>
            </Content>
        </Layout>
    </Layout>
</template>

<script>
import MyHeader from './MyHeader.vue';
import MySider from './MySider.vue';
export default {
    components: { MyHeader, MySider },
    data() {
        let name = this.$route.name;
        return {
            isCollapsed: false,
            activeName: name,
            keepAlive: [],
            tabsList: [],
            tabsVal: ''
        };
    },
    watch: {
        $route(to, from) {
            if (!this.removalArr(to.name)) {
                this.tabsList.push(to.name);
                this.keepAlive.push(to.name);
            }
            this.tabsVal = to.name;
        }
    },
    mounted() {
        this.keepAliveInitial();
    },
    methods: {
        collapsedSider() {
            this.$refs.navSider.toggleCollapse();
        },
        removalArr(val) {
            for (let i = 0; i < this.keepAlive.length; i++) { // 查找是否有包含的缓存组件
                if (this.keepAlive[i] === val) { // 如果有,直接return
                    return true;
                }
            }
            return false;
        },
        tabsClick(name) {
            this.$router.push({ name: name });
            this.activeName = name;
        },
        // tags初始化
        keepAliveInitial() {
            this.tabsList.push(this.$route.name);
            this.keepAlive.push(this.$route.name);
            this.tabsVal = this.$route.name;
        },
        // tags关闭功能
        tabsClose(type) {
            const inedx = this.keepAlive.indexOf(this.tabsVal);
            switch (type) {
            case 'left':
                if (inedx !== -1) {
                    this.keepAlive.splice(0, inedx);
                }
                break;
            case 'right':
                if (inedx !== -1) {
                    this.keepAlive.splice(inedx + 1, this.keepAlive.length);
                }
                break;
            case 'other':
                if (inedx !== -1) {
                    this.keepAlive.splice(0, inedx);
                    this.keepAlive.splice(1, this.keepAlive.length);
                }
                break;
            case 'all':
                this.keepAlive = ['首页'];
                this.tabsVal = '首页';
                this.$router.push({ name: '首页' });
                break;
            }
        },
        tabClose(name) {
            const index = this.keepAlive.indexOf(name);
            if (index === -1) {
                return;
            }
            this.keepAlive.splice(index, 1);
            if (name === this.$route.name && this.tabsVal !== -1) {
                this.$router.push({ name: this.tabsVal });
            } else if (name === this.$route.name) {
                this.$router.push({ name: '首页' });
            }
        }
    }
};
</script>

<style scoped lang="scss">
.header {
    padding: 0;
    height: 60px;
}
.content-container {
    height: 100%;
    overflow-y: auto;
    background: #f5f7f9;
    position: relative;
}
.container {
    position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;
}
.main-container {
    height: 100%;
    padding: 50px 10px 10px 10px;
    background: #ffffff;
}
.main-tabs {
    position: absolute;
    display: flex;
    width: 100%;
    background: #f5f7f9;
    padding: 4px 10px;
    .tabs-close-main {
        width: 32px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background-color: #fff;
        border-radius: 2px;
        cursor: pointer;
    }
}
.detail {
    position: absolute;
    top: 60px;
    bottom: 0;
}
</style>
<style scoped>
.main-tabs >>> .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-nav-container {
    height: 32px;
}
.main-tabs >>> .ivu-tabs-no-animation>.ivu-tabs-content {
    transform: none!important;
}
.main-tabs >>> .ivu-tabs-bar {
    border-bottom: none;
    margin-bottom: 0;
}
.main-tabs >>> .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab {
    height: 32px;
    background: #fff;
    border-radius: 3px;
    border: none;
    margin-right: 6px;
    color: #808695;
}
.main-tabs >>> .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab .ivu-icon-ios-close {
    width: 22px;
    transform: translateZ(0);
    margin-right: -6px;
}
.main-tabs >>> .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab-active {
    height: 32px;
    background: #fff;
    color: #2d8cf0!important;
}
.main-tabs >>> .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab:hover {
    color: #515a6e;
}
.main-tabs >>> .ivu-tabs {
    flex: 1;
}
</style>
